const useCursorReveal = (el) => {
    const listItems = document.querySelectorAll('.reveal-item');
    let mousepos = { x: 0, y: 0 };
    let images = [];

    if (listItems.length < 1) return;

    listItems.forEach((el, index) => {
        const image = el.dataset.image;
        images.push(image);
    });

    images = Object.entries(images);

    // update mouse position when moving the mouse
    window.addEventListener('mousemove', (e) => {
        mousepos = { x: e.clientX, y: e.clientY };
    });

    class ListItem {
        constructor(el, inListPosition, animatableProperties) {
            this.DOM = { el: el };
            this.inListPosition = inListPosition;
            this.animatableProperties = animatableProperties;
            this.DOM.textInner = this.DOM.el.querySelector('.reveal-item-inner');
            this.layout();
            this.initEvents();
        }

        layout() {
            this.DOM.reveal = document.createElement('div');
            this.DOM.reveal.className = 'hover-reveal';
            this.DOM.reveal.style.perspective = '1000px';

            this.DOM.revealInner = document.createElement('div');
            this.DOM.revealInner.className = 'hover-reveal-inner';

            this.DOM.revealImage = document.createElement('img');
            this.DOM.revealImage.className = 'hover-reveal-image reveal-image';
            this.DOM.revealImage.src = images[this.inListPosition][1];
            this.DOM.revealImage.alt = 'Praella Shopify Plus Agency - hover-reveal-image';
            this.DOM.revealImage.dataset.flipId = 'img';
            this.DOM.revealInner.appendChild(this.DOM.revealImage);
            this.DOM.reveal.appendChild(this.DOM.revealInner);
            this.DOM.el.appendChild(this.DOM.reveal);
        }

        calcBounds() {
            this.bounds = {
                el: this.DOM.el.getBoundingClientRect(),
                reveal: this.DOM.reveal.getBoundingClientRect(),
            };
        }

        initEvents() {
            this.mouseenterFn = (ev) => {
                this.showImage();
                this.firstRAFCycle = true;
                this.loopRender();
            };
            this.mouseleaveFn = (ev) => {
                this.stopRendering();
                this.hideImage();
            };
            this.mouseclickFn = () => {
                this.DOM.el.removeEventListener('mouseleave', this.mouseleaveFn);
            };

            this.DOM.el.addEventListener('mouseenter', this.mouseenterFn);
            this.DOM.el.addEventListener('mouseleave', this.mouseleaveFn);
            this.DOM.el.addEventListener('click', this.mouseclickFn);
        }

        showImage() {
            gsap.killTweensOf(this.DOM.revealInner);
            gsap.killTweensOf(this.DOM.revealImage);

            this.tl = gsap.timeline({
                onStart: () => {
                    this.DOM.reveal.style.opacity = this.DOM.revealInner.style.opacity = 1;
                    gsap.set(this.DOM.el, { zIndex: images.length });
                },
            })
            .to(this.DOM.revealInner, {
                duration: 1.2,
                ease: 'Expo.easeOut',
                startAt: { rotationY: -90, scale: 0.7 },
                rotationY: 0,
                scale: 1,
            })
            .to(this.DOM.revealImage, {
                duration: 1.2,
                ease: 'Expo.easeOut',
                startAt: { scale: 1.3, filter: 'blur(8px) brightness(2)' },
                scale: 1,
                filter: 'blur(0px) brightness(1)',
            }, 0);
        }

        hideImage() {
            gsap.killTweensOf(this.DOM.revealInner);
            gsap.killTweensOf(this.DOM.revealImage);

            this.tl = gsap.timeline({
                onStart: () => {
                    gsap.set(this.DOM.el, { zIndex: 1 });
                },
                onComplete: () => {
                    gsap.set(this.DOM.reveal, { opacity: 0 });
                },
            })
            .to(this.DOM.revealInner, {
                duration: 0.5,
                ease: 'Expo.easeOut',
                rotationY: 90,
                opacity: 0,
            });
        }

        loopRender() {
            if (!this.requestId) {
                this.requestId = requestAnimationFrame(() => this.render());
            }
        }

        stopRendering() {
            if (this.requestId) {
                window.cancelAnimationFrame(this.requestId);
                this.requestId = undefined;
            }
        }

        render() {
            this.requestId = undefined;

            if (this.firstRAFCycle) {
                this.calcBounds();
            }

            this.animatableProperties.tx.current =
                Math.abs(mousepos.x - this.bounds.el.left) - this.bounds.reveal.width / 2;
            this.animatableProperties.ty.current = -this.DOM.el.offsetHeight - 40;
            this.animatableProperties.rotation.current = map(
                Math.abs(mousepos.x - this.bounds.el.left),
                0,
                this.bounds.el.left + this.bounds.el.width,
                -20,
                20
            );

            this.animatableProperties.tx.previous = this.firstRAFCycle
                ? this.animatableProperties.tx.current
                : lerp(
                    this.animatableProperties.tx.previous,
                    this.animatableProperties.tx.current,
                    this.animatableProperties.tx.amt
                );
            this.animatableProperties.ty.previous = this.firstRAFCycle
                ? this.animatableProperties.ty.current
                : lerp(
                    this.animatableProperties.ty.previous,
                    this.animatableProperties.ty.current,
                    this.animatableProperties.ty.amt
                );
            this.animatableProperties.rotation.previous = this.firstRAFCycle
                ? this.animatableProperties.rotation.current
                : lerp(
                    this.animatableProperties.rotation.previous,
                    this.animatableProperties.rotation.current,
                    this.animatableProperties.rotation.amt
                );

            gsap.set(this.DOM.reveal, {
                x: this.animatableProperties.tx.previous,
                y: this.animatableProperties.ty.previous,
                rotation: this.animatableProperties.rotation.previous,
            });

            this.firstRAFCycle = false;
            this.loopRender();
        }
    }

    class List {
        constructor(el) {
            this.DOM = { el: el };
            this.DOM.listItems = this.DOM.el.querySelectorAll('.reveal-item');
            this.animatableProperties = {
                tx: { previous: 0, current: 0, amt: 0.08 },
                ty: { previous: 0, current: 0, amt: 0.08 },
                rotation: { previous: 0, current: 0, amt: 0.06 },
            };
            this.listItems = [];
            [...this.DOM.listItems].forEach((item, pos) =>
                this.listItems.push(
                    new ListItem(item, pos, this.animatableProperties)
                )
            );
        }
    }

    new List(el);
};

// Usage example:
useCursorReveal(document.querySelector('[data-projectsList]'));

// Helper functions
function getMousePos(e) {
    return { x: e.clientX, y: e.clientY };
}

function lerp(a, b, n) {
    return (1 - n) * a + n * b;
}

function map(value, in_min, in_max, out_min, out_max) {
    return ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
}
class project_filter {
	constructor() {
	  this.activeFilters = [];
	  this.filter();
      this.init();
	}

	parseDataTags(tagString) {
		if (!tagString) return [];
		return tagString.split(',').map((tag) => tag.trim()).filter(Boolean);
	}

	updateClearAllVisibility() {
		document.querySelectorAll('[data-case-study-filter-clear]').forEach((clearButton) => {
			if (clearButton.classList.contains('project-filter-drawer__clear')) return;
			clearButton.classList.toggle('is-hidden', this.activeFilters.length === 0);
		});
	}

	addSelectedChip(filterValue, filterLabel) {
		const selectedHtml = document.querySelector('[selected_pr_html]');
		if (!selectedHtml || selectedHtml.querySelector(`[data-project="${filterValue}"]`)) return;

		selectedHtml.insertAdjacentHTML('beforeend', `
			<div class="flex items-center text-white px-3 py-1 rounded-full text-sm mr-2 mb-2 displayed-filter" filter_remove data-project="${filterValue}">
				<p class="dynamic-button">${filterLabel}</p>
				<div class="ml-2 focus:outline-none dynamic-button" filter_remove>
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="h-4 w-4 dynamic-button">
						<path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" class="dynamic-button"></path>
					</svg>
				</div>
			</div>
		`);
	}

	removeSelectedChip(filterValue) {
		document.querySelector(`[data-project="${filterValue}"]`)?.remove();
	}

	applyFilters() {
		const selectedProject = document.querySelector('[selected_project]');
		const noRecord = document.querySelector('[no_record]');
		const gridItems = document.querySelectorAll('[data-tween][data-tag]');

		gridItems.forEach((grid) => {
			const gridTags = this.parseDataTags(grid.getAttribute('data-tag'));

			if (this.activeFilters.length > 0) {
				selectedProject?.classList.remove('hidden');
				const hasMatch = this.activeFilters.some((filter) => gridTags.includes(filter));

				if (hasMatch) {
					grid.classList.remove('hidden');
				} else {
					grid.classList.add('hidden');
				}
			} else {
				grid.classList.remove('hidden');
				selectedProject?.classList.add('hidden');
			}
		});

		const total = gridItems.length;
		const hidden = document.querySelectorAll('[data-tween][data-tag].hidden').length;
		if (total > 0 && total === hidden) {
			noRecord?.classList.remove('hidden');
		} else {
			noRecord?.classList.add('hidden');
		}

		this.updateClearAllVisibility();

		if (window.matchMedia('(max-width: 1023px)').matches) {
			refreshProjectPageScroll();
		}
	}

	clearAllFilters() {
		this.activeFilters = [];
		document.querySelectorAll('[filter_tag]').forEach((input) => {
			input.checked = false;
		});
		const selectedHtml = document.querySelector('[selected_pr_html]');
		if (selectedHtml) selectedHtml.innerHTML = '';
		this.applyFilters();
	}

	closeFilterPanel() {
		if (!this.isFilterOpen) return;

		if (window.matchMedia('(max-width: 1023px)').matches) {
			this.toggleFilterDrawer(false);
			return;
		}

		this.toggleFilterPanel(false);
	}

	isMobileFilterViewport() {
		return window.matchMedia('(max-width: 1023px)').matches;
	}

	syncFilterInputs(sourceInput) {
		const filterValue = sourceInput?.value?.trim();
		if (!filterValue) return;

		document.querySelectorAll('[filter_tag]').forEach((input) => {
			if (input.value.trim() !== filterValue) return;
			if (input === sourceInput) return;
			input.checked = sourceInput.checked;
		});
	}

	syncAllFilterInputs() {
		const seen = new Set();
		document.querySelectorAll('[filter_tag]').forEach((input) => {
			const filterValue = input.value.trim();
			if (seen.has(filterValue)) return;
			seen.add(filterValue);
			this.syncFilterInputs(input);
		});
	}

	toggleFilterDrawer(open) {
		const drawer = document.querySelector('#project-filter-drawer');
		const filter_btn = document.querySelector('[filter_btn]');
		const toggle_button = document.querySelector('[data-project-filter-toggle]');
		if (!drawer) return;

		this.isFilterOpen = open;
		drawer.classList.toggle('is-open', open);
		drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
		filter_btn?.classList.toggle('open', open);
		toggle_button?.setAttribute('aria-expanded', open ? 'true' : 'false');
		document.body.classList.toggle('project-filter-drawer-open', open);

		if (open) this.syncAllFilterInputs();

		if (open) {
			requestAnimationFrame(() => {
				refreshPlatformGroupsScrollbars();
			});
		}
	}

	toggleFilterPanel(open) {
		const panel = document.querySelector('#accordion-collapse-body-1');
		const filter_btn = document.querySelector('[filter_btn]');
		const toggle_button = document.querySelector('[data-project-filter-toggle]');
		if (!panel) return;

		this.isFilterOpen = open;
		panel.classList.toggle('is-open', open);
		filter_btn?.classList.toggle('open', open);
		toggle_button?.setAttribute('aria-expanded', open ? 'true' : 'false');
		panel.setAttribute('aria-hidden', open ? 'false' : 'true');

		if (open) {
			requestAnimationFrame(() => {
				this.syncPlatformsHeightToIndustries();
				refreshPlatformGroupsScrollbars();
			});
		}
	}

	syncPlatformsHeightToIndustries() {
		document.querySelectorAll('[data-case-study-platforms-list]').forEach((platformsWrap) => {
			const filtersRoot = platformsWrap.closest('.case-study-filters');
			const industriesList = filtersRoot?.querySelector('.industrygroup .case-study-filter__list');

			if (this.isMobileFilterViewport() || !industriesList) {
				platformsWrap.style.removeProperty('--platforms-matched-height');
				return;
			}

			platformsWrap.style.setProperty('--platforms-matched-height', `${industriesList.offsetHeight}px`);
		});
	}

    init(){
        const accordion_button = document.querySelector('[data-project-filter-toggle]');
        const panel = document.querySelector('#accordion-collapse-body-1');

        if (accordion_button && panel) {
            this.isFilterOpen = false;

            accordion_button.addEventListener('click', (event) => {
                event.preventDefault();
                if (this.isMobileFilterViewport()) {
                    this.toggleFilterDrawer(!this.isFilterOpen);
                    return;
                }
                this.toggleFilterPanel(!this.isFilterOpen);
            });
        }

        document.querySelectorAll('[data-project-filter-drawer-close]').forEach((closeTrigger) => {
            closeTrigger.addEventListener('click', () => {
                this.closeFilterPanel();
            });
        });

        document.querySelector('#project-filter-drawer')?.addEventListener('click', (event) => {
            if (!document.body.classList.contains('project-filter-drawer-open')) return;
            if (event.target.closest('.project-filter-drawer__sheet')) return;
            this.closeFilterPanel();
        });

        document.body.addEventListener('click', (event) => {
            if (!document.body.classList.contains('project-filter-drawer-open')) return;
            if (event.target.closest('.custom-body-overlay')) {
                this.closeFilterPanel();
            }
        });

        document.querySelectorAll('[data-filter-accordion-toggle]').forEach((button) => {
            button.addEventListener('click', () => {
                if (!this.isMobileFilterViewport()) return;

                const group = button.closest('[data-filter-accordion]');
                if (!group) return;

                const willOpen = !group.classList.contains('is-open');
                group.classList.toggle('is-open', willOpen);
                button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');

                if (group.classList.contains('platformgroup')) {
                    window.setTimeout(refreshPlatformGroupsScrollbars, 350);
                }
            });
        });

        document.querySelector('[data-case-study-filter-close]')?.addEventListener('click', () => {
            this.closeFilterPanel();
        });

        document.querySelectorAll('[data-case-study-filter-clear]').forEach((clearButton) => {
            clearButton.addEventListener('click', () => {
                this.clearAllFilters();
            });
        });

        this.syncPlatformsHeightToIndustries();
        window.addEventListener('resize', () => {
            this.syncPlatformsHeightToIndustries();
            refreshPlatformGroupsScrollbars();
        }, { passive: true });

        initPlatformGroupsScrollbars();
    }

    filter(){
        document.querySelectorAll('[filter_tag]').forEach((input) => {
            input.addEventListener('change', (event) => {
                const currentInput = event.currentTarget;
                this.syncFilterInputs(currentInput);
                const filterValue = currentInput.value.trim();
                const filterLabel = currentInput.dataset.filterLabel || filterValue.split('_').slice(1).join(' ').replace(/-/g, ' ');

                if (currentInput.checked) {
                    if (!this.activeFilters.includes(filterValue)) {
                        this.activeFilters.push(filterValue);
                    }
                    this.addSelectedChip(filterValue, filterLabel);
                } else {
                    this.activeFilters = this.activeFilters.filter((value) => value !== filterValue);
                    this.removeSelectedChip(filterValue);
                }

                this.applyFilters();
            });
        });

        document.body.addEventListener('click', (event) => {
            if (!event.target?.classList.contains('dynamic-button')) return;

            const chip = event.target.closest('[data-project]');
            const filterValue = chip?.getAttribute('data-project');
            if (!filterValue) return;

            const matchingInput = Array.from(document.querySelectorAll('[filter_tag]')).find(
                (input) => input.value.trim() === filterValue
            );
            if (matchingInput) {
                matchingInput.checked = false;
                matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
            }
        });
    }
}

function refreshProjectPageScroll() {
	if (typeof ScrollTrigger === 'undefined') return;

	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			if (typeof ScrollSmoother !== 'undefined') {
				ScrollSmoother.get()?.refresh();
			}
			ScrollTrigger.refresh();
		});
	});
}

function initPlatformGroupsScrollbars(root = document) {
	root.querySelectorAll('[data-platform-groups-scroll]').forEach((wrap) => {
		if (wrap.dataset.platformScrollbarInit) return;
		wrap.dataset.platformScrollbarInit = 'true';

		const groups = wrap.querySelector('.case-study-filter-platforms__groups');
		const thumb = wrap.querySelector('.case-study-filter-platforms__scrollbar-thumb');
		if (!groups || !thumb) return;

		const update = () => {
			const { scrollHeight, clientHeight, scrollTop } = groups;
			const scrollable = scrollHeight > clientHeight + 1;

			wrap.classList.toggle('is-scrollable', scrollable);
			if (!scrollable) return;

			const trackHeight = clientHeight;
			const thumbHeight = Math.max((clientHeight / scrollHeight) * trackHeight, 16);
			const maxScrollTop = scrollHeight - clientHeight;
			const maxThumbTop = trackHeight - thumbHeight;
			const thumbTop = maxScrollTop > 0 ? (scrollTop / maxScrollTop) * maxThumbTop : 0;

			thumb.style.height = `${thumbHeight}px`;
			thumb.style.transform = `translate3d(0, ${thumbTop}px, 0)`;
		};

		groups.addEventListener('scroll', update, { passive: true });
		if (typeof ResizeObserver !== 'undefined') {
			const observer = new ResizeObserver(update);
			observer.observe(groups);
		}
		window.addEventListener('resize', update, { passive: true });
		wrap._updatePlatformScrollbar = update;
		update();
	});
}

function refreshPlatformGroupsScrollbars() {
	document.querySelectorAll('[data-platform-groups-scroll]').forEach((wrap) => {
		wrap._updatePlatformScrollbar?.();
	});
}

function initProjectGridViewportVideos() {
    const projectVideos = document.querySelectorAll(
        '.projects-grid custom-video[data-viewport-autoplay="true"]'
    );
    if (!projectVideos.length) return;

    const viewportObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const video = entry.target.querySelector('video');
                if (!video) return;

                if (entry.isIntersecting) {
                    video.muted = true;
                    video.play().catch(() => {});
                } else {
                    video.pause();
                }
            });
        },
        { threshold: 0.35 }
    );

    projectVideos.forEach((customVideoEl) => {
        const video = customVideoEl.querySelector('video');
        if (video) {
            video.muted = true;
            video.pause();
        }
        viewportObserver.observe(customVideoEl);
    });
}

function initFeaturedGridTitlePin() {
  const section = document.querySelector('.featured-p-grid');
  const title = document.querySelector('.featured-p-grid__title');
  if (!section || !title) return;

  const featuredGridPin = gsap.matchMedia();
  const smoothWrapper = document.getElementById('smooth-wrapper');
  const pinType = document.getElementById('smooth-content') ? 'transform' : 'fixed';

  const createPin = (isDesktop) => {
    const getTravelDistance = () => {
      const sectionHeight = section.offsetHeight;
      const titleHeight = title.offsetHeight;

      if (isDesktop) {
        return Math.max(0, (sectionHeight - titleHeight) / 2);
      }

      const titleTop = parseFloat(getComputedStyle(title).top) || 85;
      return Math.max(0, sectionHeight - titleTop - titleHeight);
    };

    const scrollTriggerConfig = {
      trigger: section,
      start: 'top top',
      end: () => `+=${getTravelDistance()}`,
      pin: title,
      pinSpacing: false,
      pinReparent: false,
      anticipatePin: 1,
      invalidateOnRefresh: true,
    };

    if (smoothWrapper) {
      scrollTriggerConfig.scroller = smoothWrapper;
      scrollTriggerConfig.pinType = pinType;
    }

    const pinTween = gsap.to(title, {
      scrollTrigger: scrollTriggerConfig,
    });

    return () => {
      pinTween.scrollTrigger?.kill();
      pinTween.kill();
      gsap.set(title, { clearProps: 'left,top,width,transform,maxWidth,position' });
    };
  };

  featuredGridPin.add('(min-width: 1024px)', () => createPin(true));
  featuredGridPin.add('(max-width: 1023px)', () => createPin(false));

  const refreshPin = () => ScrollTrigger.refresh();
  if (typeof imagesLoaded === 'function') {
    imagesLoaded(section, refreshPin);
  } else {
    refreshPin();
  }
}

function initFeaturedGridParallax() {
  const section = document.querySelector('.featured-p-grid');
  if (!section || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  const items = gsap.utils.toArray('.featured-p-grid .grid-items');
  if (!items.length) return;

  const smoothWrapper = document.getElementById('smooth-wrapper');
  const parallaxAmounts = [
    { speed: 0.13 },
    { speed: 0.5 },
    { speed: 0.3 },
  ];

  const mm = gsap.matchMedia();

  const setupParallax = (intensity) => {
    const tweens = items.map((el, index) => {
      const { speed } = parallaxAmounts[index] ?? parallaxAmounts[0];
      const scrollTriggerConfig = {
        trigger: section,
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true,
      };

      if (smoothWrapper) scrollTriggerConfig.scroller = smoothWrapper;

      gsap.set(el, { y: 0, force3D: true });

      return gsap.fromTo(
        el,
        { y: 0, immediateRender: false },
        {
          y: () => -section.offsetHeight * speed * intensity,
          ease: 'none',
          immediateRender: false,
          scrollTrigger: scrollTriggerConfig,
        }
      );
    });

    return () => {
      tweens.forEach((tween) => {
        tween.scrollTrigger?.kill();
        tween.kill();
      });
      items.forEach((el) => gsap.set(el, { clearProps: 'transform' }));
    };
  };

  mm.add('(min-width: 1024px)', () => setupParallax(0.8));
  mm.add('(max-width: 1023px)', () => setupParallax(0.3));

  const refreshParallax = () => ScrollTrigger.refresh();
  if (typeof imagesLoaded === 'function') {
    imagesLoaded(section, refreshParallax);
  } else {
    refreshParallax();
  }
}

typeof project_filter !== 'undefined' && new project_filter();
initProjectGridViewportVideos();
initFeaturedGridTitlePin();
initFeaturedGridParallax();
window.addEventListener('load', () => ScrollTrigger.refresh());